module.exports = __webpack_public_path__ + "static/img/backGround3.0b91640.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backGround3.jpg
// module id = 2ikY
// module chunks = 1